import * as React from "react";
import { Button, Card } from "antd";
import { CardTitle } from "../../../components/antd/card/CardTitle";
import { SecretDataAWS } from "./aws";
import { SecretDataAzureConnector } from "./azureConnector";
import { SecretDataAzureSDK } from "./azureSdk";
import { SecretDataDictionary } from "./dictionary";
import { SecretDataDocker } from "./docker";
import { SecretDataECR } from "./ecr";
import { SecretDataGCP } from "./gcp";
import { SecretDataKeypair } from "./keypair";
import { SecretDataNatsAccount } from "./natsAccount";
import { SecretDataOpaque } from "./opaque";
import { SecretDataTLS } from "./tls";
import { SecretDataUserpass } from "./userpass";
import { FormItemDescription } from "../../../components/antd/form/FormItemDescription";
import { useCpFormValue } from "../../gvc/testNewForm/utils";
import { CpErrorWarningArrayIcon } from "../../gvc/testNewForm/CpErrorWarningArrayIcon";
import { SecretTypeOptions } from "../utils";

interface Props {
  revealSecret?: any;
  isLoading?: boolean;
  isFetching?: boolean;
}
export const Data: React.FC<Props> = ({ revealSecret, isFetching, isLoading }) => {
  const isEdit = useCpFormValue(`meta.isEdit`);

  const type = useCpFormValue(`type`);
  const isRevealed = useCpFormValue(`meta.revealed`);

  const typeLabel = SecretTypeOptions.find((o) => o.value === type)?.label || "";

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>
            <div className="flex items-start">
              <span>Data{typeLabel ? ` | ${typeLabel}` : ""}</span>
              <div style={{ transform: "translateY(0px)" }}>
                <CpErrorWarningArrayIcon
                  names={[
                    `aws`,
                    `azureConnector`,
                    `azureSdk`,
                    `dictionary`,
                    `docker`,
                    `ecr`,
                    `gcp`,
                    `keypair`,
                    `natsAccount`,
                    `opaque`,
                    `tls`,
                    `userpass`,
                  ]}
                />
              </div>
            </div>
          </CardTitle>
          {(isEdit && isRevealed) || !isEdit ? (
            <>
              {type === "aws" ? <SecretDataAWS /> : null}
              {type === "azure-connector" ? <SecretDataAzureConnector /> : null}
              {type === "azure-sdk" ? <SecretDataAzureSDK /> : null}
              {type === "dictionary" ? <SecretDataDictionary /> : null}
              {type === "docker" ? <SecretDataDocker /> : null}
              {type === "ecr" ? <SecretDataECR /> : null}
              {type === "gcp" ? <SecretDataGCP /> : null}
              {type === "keypair" ? <SecretDataKeypair /> : null}
              {type === "nats-account" ? <SecretDataNatsAccount /> : null}
              {type === "opaque" ? <SecretDataOpaque /> : null}
              {type === "tls" ? <SecretDataTLS /> : null}
              {type === "userpass" ? <SecretDataUserpass /> : null}
            </>
          ) : (
            <div>
              <div className="mb-2">
                <FormItemDescription>
                  Secret reveal actions are kept track in the audit trail. To view or edit the secret data, it needs to
                  be revealed.
                </FormItemDescription>
              </div>
              <Button onClick={revealSecret} disabled={isLoading || isFetching} loading={isLoading || isFetching}>
                Reveal Secret
              </Button>
            </div>
          )}
        </Card>
      </div>
    </>
  );
};
